<template>

    <v-container grid-list-xl full-width fill-width>
        <v-layout wrap py-5 >
            <v-flex xs12>
                    <p>Cadastre todos as pessoas que fizeram parte do seu projeto.<br>
                    Os interpretes, os músicos (baxista, tecladista, corneta, etc) e também produtores fonográficos. </p>
            </v-flex>
            <v-flex xs12 md12 xl12>
                <v-card class="px-3 py-3" elevation="0" style="border:1px solid #999">
                   
                    <v-layout wrap>
                        <v-flex xs12 md3>
                            <v-text-field
                            label="Nome Completo"
                            v-model="titular.fullname"                            
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 md3>
                            <v-text-field
                            label="Pseudônimo"
                            v-model="titular.alias"                            
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 md3>
                            <v-text-field
                            v-model="titular.cpf_cnpj"
                            label="CPF / CNPJ"                            
                            ></v-text-field>
                        </v-flex>

                        <v-flex xs12 md3 style="align-self:center; text-align:center">
                            <v-btn @click="add_titular" color="primary"> <v-icon>add</v-icon> TITULAR</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

            <v-flex xs12 md12>
 <v-data-table
    :headers="headers"
    :items="titulares"
    :items-per-page="500"
    class="elevation-1"
    hide-default-footer
  ></v-data-table>
            </v-flex>
        </v-layout>
    </v-container>

</template>
<script>
export default {
    props:{
        titulares: Array
    },
    data(){
        return {
            titular:{},
            //titulares:[],
            //tabela
            headers: [
                {
                    text: '#',
                    align: 'left',
                    sortable: false,
                    value: 'indice',
                },
                { text: 'Nome Completo', value: 'fullname' },
                { text: 'Pseudônimo', value: 'alias' },
                { text: 'CPF/CNPJ', value: 'cpf_cnpj' },
                ],
        };
    },
    methods:{
        add_titular(){
            //adicionar uma validação dos campos aqui
            this.titular.indice = this.titulares.length + 1;
            this.titulares.push(
                JSON.parse(JSON.stringify(this.titular))
            );

            this.titular = {};
        }
    }
}
</script>